import { formFieldsConfigProcessed } from "./config/ClaimInformationConfig";
import { formFieldsState } from "./state/ClaimInformationState";
import { formFieldsValidation } from "./validations/ClaimInformationValidations";
import { CLAIM_INFORMATION_CONSTANTS } from "../../constants";

export const formName = CLAIM_INFORMATION_CONSTANTS.FORM_NAME;
export const formState = formFieldsState;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;

export { formFieldsConfigProcessed, formFieldsState, formFieldsValidation };
